import styled from "styled-components";

export const Line = styled.div`
    border-bottom: 0.5px solid #FFFFFF;
    width: 100%;
`;